import React from 'react';
import { connect } from 'react-redux';

import { getLangCountryPrefix } from 'helpers/utils';

import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';

const UnsubscribeSuccess = (props) => {
    return (
        <PromoInfoPage
            animatedIconSuccess
            headerText={props.emailUnsubscribeSuccess}
            primaryButtonType="link"
            primaryButtonCaption={props.emailUnsubscribeHomePage}
            primaryButtonLink={getLangCountryPrefix(props.lang, props.country)}
        />
    );
};
const mapStateToProps = (state) => {
    return {
        emailUnsubscribeSuccess: state.messages.pageMessages.emailUnsubscribeSuccess,
        emailUnsubscribeHomePage: state.messages.pageMessages.emailUnsubscribeHomePage,
        lang: state.language.lang,
        country: state.app.country,
    };
};

export default connect(mapStateToProps)(UnsubscribeSuccess);
